// For mobile displays button based on the device (apple or android) and the store
// For desktop displays both buttons

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import { useBreakpointsMediaUp } from '@nubank/nuds-web/styles/breakpoints';

import AppStoreBadge from '../../../../components/AppStoreBadge/AppStoreBadge';
import AppStoreButtonsContainer from '../DecisionStep/styles/AppStoreButtonsContainer';
import useMobileOS from '../../../../utils/hooks/useMobileOS';
import { redirectionEvent } from '../../tracking';

const ButtonContainer = styled(AppStoreButtonsContainer)`
  border-radius: 25px;
  background-color: ${props => (props.showBothButtons ? 'auto' : 'black')};
  margin-right: ${props => (props.showBothButtons ? '2px' : '1.125rem')};
  width: ${props => (props.showBothButtons ? 'auto' : '100%')};
  
  div {
    border-radius: 5px;
    padding: 1px 8px;
    background-color: ${props => (props.showBothButtons ? 'black' : 'auto')};
    height: 100%;

  }
`;

const StoresButtons = ({ link }) => {
  const mobileSystem = useMobileOS();
  const isDesktop = useBreakpointsMediaUp('lg');

  const redirectToStore = () => {
    window.open(link, '_blank');
    redirectionEvent('click-store-button');
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column' }}
      alignItems={{ xs: 'center' }}
      marginTop={{ xs: '8x' }}
      marginLeft={!isDesktop && mobileSystem !== 'other' ? '4x' : '0x'}
    >

      <ButtonContainer showBothButtons={isDesktop || mobileSystem === 'other'}>
        { isDesktop || (mobileSystem === 'ios' || mobileSystem === 'other')
          ? (
            <Box onClick={() => redirectToStore()}>
              <AppStoreBadge platform="ios" variant="dark" />
            </Box>
          )
          : null}
        { isDesktop || (mobileSystem === 'android' || mobileSystem === 'other')
          ? (
            <Box onClick={() => redirectToStore()}>
              <AppStoreBadge platform="android" variant="dark" />
            </Box>
          )
          : null}
      </ButtonContainer>
    </Box>
  );
};

StoresButtons.propTypes = {
  link: PropTypes.string.isRequired,
};

export default StoresButtons;
